import React, { useState } from 'react';
import { useEffect } from 'react';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'react-headless-accordion';
import { IoIosArrowBack } from 'react-icons/io';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Treatment from './Treatment';

const Accordions = ({ phoneNumber, email, days, hours }) => {



  function formatIsraeliPhoneNumber(phoneNumber) {
    // Remove all non-digit characters from the phone number
    const cleanedNumber = phoneNumber.replace(/\D/g, "");

    // Check if the number starts with "972" and remove it if present
    const formattedNumber = cleanedNumber.startsWith("972") ? cleanedNumber.slice(3) : cleanedNumber;

    // Insert dashes in the appropriate places and add a leading "0"
    const formattedWithZero = `0${formattedNumber.slice(0, 2)}-${formattedNumber.slice(2, 5)}-${formattedNumber.slice(5)}`;

    return formattedWithZero;
  }


  const handleClick = () => {
    window.location.href = `mailto:${email}`;
  };

  var formattedPhoneNumber = formatIsraeliPhoneNumber(phoneNumber);

  const [rotationStates, setRotationStates] = useState({});

  const toggleRotation = (accordionIndex) => {
    setRotationStates((prevState) => ({
      ...prevState,
      [accordionIndex]: !prevState[accordionIndex],
    }));
  };

  const accordionTransitionDuration = 800; // Set the same duration as the accordion transition

  return (
    <div className='py-4 ' >
      <div className='max-w-[450px] card border-transparent bg-transparent shadow-xl mx-auto'>
        <div>







          <Treatment
            headline="טיפול זוהר"
            info="ניקוי ראשוני, פיליניג ,מסיכה, עיסוי הפנים, החדרת לחות וויטמינים."
            time="40"
          />


          <Treatment
            headline="טיפול קלאסי"
            info="ניקוי עמוק והוצאת קומודונים (שחורים) מסכה, עיסוי הפנים, החדרת לחות, וויטמינים."
            time="70"
          />

          <Treatment
            headline="טיפול באבנים חמות משולב עם מסכות ועיסוי פנים"
            info="מסכה מתקלפת לטיהור וניקוי לכל סוגי העור החדרת לחות ,וויטמינים לעור. עיסוי פנים ושימוש באבנים חמות לעיסוי והרגעת העור."
            time="45"
          />

          <Treatment
            headline="טיפול מזותרפיה"
            info="מיועד לסייע בחידוש סיבי הקולגן  בעור בעזרת עידוד יצירת הסיבים שמטרתם לשפר את זרימת הדם לעור. במיוחד במצבי פוסט אקנה . "
            time="45"
          />


          <div data-aos="zoom-in" data-aos-easing="linear" data-aos-duration="500" data-aos-delay="0">
            <Accordion
              className='hover:opacity-95 card bg-gradient-to-l from-mainBtn to-secondaryBtn text-textBtn border-4 border-borderBtn text-2xl font-semibold p-4 m-4 shadow-lg'
              transition={{ duration: `${accordionTransitionDuration}ms`, timingFunction: 'cubic-bezier(0, 0, 0.2, 1)' }}
            >
              <AccordionItem>
                <AccordionHeader
                  className='items-center flex justify-between'
                  onClick={() => toggleRotation(3)}
                >
                  <IoIosArrowBack
                    className={rotationStates[3] ? 'rotate-90' : ''}
                    style={{ transition: `transform 0.4s ease-in-out` }}

                  />
                  <h3 className={`accordion-title  pink-rose-text`}>תקשורת ושעות פעילות</h3>
                </AccordionHeader>

                <AccordionBody className='card-normal text-accordionText'>
                  <div className='accordion-body'>
                    <div className='card shadow-xl mx-auto text-right '>
                      <div className='text-right p-4'>
                        <p className='font-semibold text-xl mb-1 mt-4 pink-rose-text'>טלפון</p>
                        <a href={`tel:${phoneNumber}`} className='text-lg font-normal' target="_blank" >
                          {formattedPhoneNumber}
                        </a>
                        {/* <p className='font-medium text-base my-1'>מייל</p>
                        <a href={`mailto:${email}`} className='text-lg font-normal' onClick={handleClick} target="_blank" >
                          {email}
                        </a> */}
                        <p className='font-semibold text-xl mb-1 mt-4 pink-rose-text'>שעות פעילות</p>
                        <p className='font-medium text-base mb-1 mt-2' dir='rtl'>ימים {days}</p>
                        <p className='text-lg font-normal' >{hours}</p>
                        {/* <p className='font-medium text-base mb-1 mt-2' dir='rtl'>יום ה'</p>
                        <p className='text-lg font-normal' dir=''>16:00 - 19:00</p> */}
                        <p className='font-medium text-base mb-1 mt-2' dir='rtl'>יום ו'</p>
                        <p className='text-lg font-normal' dir=''>08:00 - 12:00</p>
                        <p className='font-semibold text-xl mb-1 mt-4 pink-rose-text'>כתובת</p>
                        <p className='font-medium text-base mb-1 mt-2' dir='rtl'>מגדלי IQ רחובות</p>


                      </div>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div></div>

  );
};

export default Accordions;
